import {
  ADD_SENDER_BRANCH_FAIL,
  ADD_SENDER_BRANCH_REQUEST,
  ADD_SENDER_BRANCH_SUCCESS,
  DELETE_SENDER_BRANCH_FAIL,
  DELETE_SENDER_BRANCH_REQUEST,
  DELETE_SENDER_BRANCH_SUCCESS,
  GET_SENDER_BRANCH_LIST_FAIL,
  GET_SENDER_BRANCH_LIST_REQUEST,
  GET_SENDER_BRANCH_LIST_SUCCESS,
  GET_SINGLE_SENDER_BRANCH_FAIL,
  GET_SINGLE_SENDER_BRANCH_REQUEST,
  GET_SINGLE_SENDER_BRANCH_SUCCESS,
  UPDATE_SENDER_BRANCH_FAIL,
  UPDATE_SENDER_BRANCH_REQUEST,
  UPDATE_SENDER_BRANCH_SUCCESS,
} from "src/constants/types";

export const senderBranchReducers = (state = {}, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_SENDER_BRANCH_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_SENDER_BRANCH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        senderBranches: payload,
        error: "",
      };

    case GET_SENDER_BRANCH_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_SENDER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_SENDER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        senderBranch: actions.payload,
      };
    case GET_SINGLE_SENDER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_SENDER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SENDER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_SENDER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_SENDER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_SENDER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_SENDER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_SENDER_BRANCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SENDER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_SENDER_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
